import React from 'react';
import { generateRandomKey } from './util';
import { IABSProductCompare } from './IABSProductCompare';
import _ from 'lodash';

const dealCompareResultKeys = ['avg_issuer_count', 'avg_asset_count', 'avg_balance_single_issuer', 'orig_wac', 'orig_wal', 'curr_wac', 'curr_wal', 'annualized_cum_default_rate', 'annualized_cum_prepayment_rate'];

export default class ABSProductCompareDataHelper extends React.Component {
  // static getRatingColumns() {
  //   const { ratingColumnsData } = util;
  //   return ratingColumnsData.map((column) => {
  //     return {
  //       column.render = (text) => {
  //         return {
  //           children: <span>{text}</span>,
  //           props: {
  //             colSpan: 2,
  //           },
  //         };
  //       }
  //     };
  //   });
  // }

  static formatTableDataSource(dealCompareResult: IABSProductCompare, columnsData: any[], contentData: any[]) {
    const key: string = generateRandomKey(5);
    columnsData.push({
      title: dealCompareResult.deal.col_name,
      dataIndex: key,
      key: key,
      width: 200,
    });

    contentData = contentData.map((row, index) => {
      const value = _.get(dealCompareResult, `deal.${[dealCompareResultKeys[index]]}`, '');
      row[key] = value;
      return row;
    });
    return { columnsData, contentData };
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/absui/ABSProductCompare/ABSProductCompareDataHelper.tsx